import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d42814c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "doctorRegistration" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "의료진 등록", -1))
const _hoisted_3 = { class: "content-left regist-info1" }
const _hoisted_4 = { action: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "기본 정보", -1))
const _hoisted_7 = { class: "input-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "doctorName" }, "이름", -1))
const _hoisted_9 = { class: "input-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "id" }, "아이디(이메일)", -1))
const _hoisted_11 = { class: "input-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "비밀번호", -1))
const _hoisted_13 = { class: "input-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "passwordRe" }, "비밀번호 확인", -1))
const _hoisted_15 = { class: "input-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "metaverseUrl" }, "메타버스 계정", -1))
const _hoisted_17 = { class: "input-item nationality" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nationality" }, "국가", -1))
const _hoisted_19 = { class: "options-wrap search-wrap" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "input-item medical-subject-kr" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "전문 진료과목", -1))
const _hoisted_23 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_24 = { class: "options" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "input-item medical-disease-kr" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "하위 진료질환", -1))
const _hoisted_28 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_29 = { class: "options" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "option-results"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "input-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "licenseNumber" }, "의료진 면허번호", -1))
const _hoisted_35 = { class: "input-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "licenseImage" }, "의료진 면허 & 여권 사진", -1))
const _hoisted_37 = {
  class: "label-file",
  for: "licenseImage"
}
const _hoisted_38 = { class: "file-box" }
const _hoisted_39 = { class: "thumbnail" }
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-attatch hidden-font" }, "사진 첨부", -1))
const _hoisted_42 = { class: "img-preview" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "input-item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profileImage" }, "의료진 프로필 사진", -1))
const _hoisted_47 = {
  class: "label-file",
  for: "profileImage"
}
const _hoisted_48 = { class: "file-box" }
const _hoisted_49 = { class: "thumbnail" }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-attatch hidden-font" }, "사진 첨부", -1))
const _hoisted_52 = { class: "img-preview" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "right-wrap" }
const _hoisted_56 = { class: "content-right regist-info2" }
const _hoisted_57 = { class: "lang-tabs" }
const _hoisted_58 = { class: "lang-content info2-en" }
const _hoisted_59 = { action: "" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lang-tabs" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "lang-tab-en on" }, "영어")
], -1))
const _hoisted_63 = { class: "input-item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliationEn" }, "Affiliated hospital", -1))
const _hoisted_65 = { class: "input-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "activityEn" }, "Activity/Press report", -1))
const _hoisted_67 = { class: "input-item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "educationEn" }, "Education/Career", -1))
const _hoisted_69 = {
  key: 0,
  class: "lang-content info2-kr"
}
const _hoisted_70 = { class: "" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보(한국어)", -1))
const _hoisted_72 = { class: "input-item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliaitionKr" }, "소속", -1))
const _hoisted_74 = { class: "input-item" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "activityKr" }, "학술활동/언론보도", -1))
const _hoisted_76 = { class: "input-item" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "학력/경력", -1))
const _hoisted_78 = {
  key: 1,
  class: "lang-content info2-ru"
}
const _hoisted_79 = { action: "" }
const _hoisted_80 = { class: "" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보(러시아어)", -1))
const _hoisted_82 = { class: "input-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliationRu" }, "Аффилированная госпиталь", -1))
const _hoisted_84 = { class: "input-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Отчет об активности/Для прессы", -1))
const _hoisted_86 = { class: "input-item" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Образование/карьера", -1))
const _hoisted_88 = {
  key: 0,
  class: "currentPopup"
}
const _hoisted_89 = {
  key: 0,
  class: "resultPopup"
}

import { onBeforeMount, watch } from 'vue';
import { computed, ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { DrState } from '@/store/modules/doctor';
import ExceptionPopup from '@/components/popup/ExceptionPopup.vue';
import ResultPopup from '@/components/popup/ResultPopup.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorRegist',
  emits: ['offLoadingLayer'],
  setup(__props, { emit }) {

const store = useStore();
const router = useRouter();
const Dr: DrState = store.state.moduleDr;

/**** popup ------------------- */
var currentPopup = ref(null);
var popupTitle = ref('');
var popupDesc = ref('');
var exception = computed(() => Dr.exception);
var result = computed(() => Dr.result);
let onCallMethod = () => {
  return console.log('on call');
};
const close_currentPopup = () => {
  currentPopup.value = null;
};
const close_resultPopup = async () => {
  store.commit('moduleDr/reset_result', { root: true });
  await router.go(0);
};
const onClick_cancel = () => {
  close_currentPopup();
};
const onClick_close = () => {
  close_currentPopup();
};
const onClick_confirm = async () => {
  close_currentPopup();
  onCallMethod();
};
/**** data -------------------- */
var nationalityList = computed(() => Dr.nationalityList);
var nationalityList_name = computed(() => store.getters['moduleDr/getNationalityList_name']);
var isOn_nationality_option = ref(false);
var selectedDisease_name = '진료질환 선택';
var selectedSubject_name = '진료과목 선택';
var subjects = computed(() => Dr.subjects);
var diseases_onSubject = computed(() => Dr.diseases_onSubject);
var nationality_result = ref({});
var subject_result = ref(null);
var diseases_result = ref([]);
var regSubjectCodes = ref([]);
var isOn_nationality_result = ref(false);
var isOn_diseases_result = ref(false);
var doctorResult = computed(() => Dr.doctorResult);
var doctorRegist = ref({
  doctorName: ``,
  doctorEmail: ``,
  password: ``,
  passwordRe: ``,
  metaverseUrl: `https://`,
  nationality: ``,
  diseases: [], // subject_disease_dto
  licenseNumber: ``,
  licenseImage: null,
  profileImage: null,
  affiliationEn: ``,
  activityEn: ``,
  educationEn: ``,
  affiliationKr: ``,
  activityKr: ``,
  educationKr: ``,
  affiliationRu: ``,
  activityRu: ``,
  educationRu: ``,
});
var isValid = ref({
  doctorName: false,
  doctorEmail: false,
  password: false,
  passwordRe: false,
  metaverseUrl: true,
  nationality: false,
  diseases: true,
  licenseNumber: false,
  licenseImage: false,
  profileImage: false,
  affiliationEn: false,
  activityEn: false,
  educationEn: false,
  affiliationKr: true,
  activityKr: true,
  educationKr: true,
  affiliationRu: true,
  activityRu: true,
  educationRu: true,
});
var validMsg = ref({
  doctorName: `필수 입력 사항`,
  doctorEmail: `필수 입력 사항`,
  password: `필수 입력 사항`,
  passwordRe: `필수 입력 사항`,
  metaverseUrl: `선택 입력 사항`,
  nationality: `필수 입력 사항`,
  diseases: `선택 입력 사항`,
  licenseNumber: `필수 입력 사항`,
  licenseImage: `필수 입력 사항`,
  profileImage: `필수 입력 사항`,
  affiliationEn: `필수 입력 사항`,
  activityEn: `필수 입력 사항`,
  educationEn: `필수 입력 사항`,
  affiliationKr: `선택 입력 사항`,
  activityKr: `선택 입력 사항`,
  educationKr: `선택 입력 사항`,
  affiliationRu: `선택 입력 사항`,
  activityRu: `선택 입력 사항`,
  educationRu: `선택 입력 사항`,
});
var licenseImage = ref({
  name: `.gif, .jpeg, .png (200kb 이하)`,
  type: ``,
  size: 0,
  url: ``,
  thumbnail: ``,
});
var profileImage = ref({
  name: `.gif, .jpeg, .png (200kb 이하)`,
  type: ``,
  size: 0,
  url: ``,
  thumbnail: ``,
});
const reset_options = () => {
  isOn_nationality_option.value = false;
  isOn_subject_option.value = false;
  isOn_diseases_option.value = false;
};
var isOn_subject_option = ref(false);
var isOn_diseases_option = ref(false);

var onClick_tabKr = () => {
  isOn_tabKr.value = true;
  isOn_tabRu.value = false;
};
var onClick_tabRu = () => {
  isOn_tabKr.value = false;
  isOn_tabRu.value = true;
};
var isOn_eyeslash = ref(false);
var onClick_eyeslash = () => {
  var pw = document.getElementById('password') as HTMLElement;
  if (isOn_eyeslash.value) {
    isOn_eyeslash.value = false;
    pw.setAttribute('type', 'password');
  } else {
    isOn_eyeslash.value = true;
    pw.setAttribute('type', 'text');
  }
};
var isOn_eyeslashRe = ref(false);
var onClick_eyeslashRe = () => {
  var pw = document.getElementById('passwordRe') as HTMLElement;
  if (isOn_eyeslashRe.value) {
    isOn_eyeslashRe.value = false;
    pw.setAttribute('type', 'password');
  } else {
    isOn_eyeslashRe.value = true;
    pw.setAttribute('type', 'text');
  }
};
var isOn_tabKr = ref(true);
var isOn_tabRu = ref(false);

/**** methods ----------------- */
const setNationalityList = () => {
  const word = ``;
  store.dispatch('moduleDr/getNationalityList', word, { root: true });
};
const checkValid_doctorName = async () => {
  let reg_doctorName = /^(?=.{3,40}$).*/;
  if (doctorRegist.value.doctorName === ``) {
    isValid.value.doctorName = false;
    validMsg.value.doctorName = `필수 입력 사항`;
  } else {
    if (!reg_doctorName.test(doctorRegist.value.doctorName)) {
      isValid.value.doctorName = false;
      validMsg.value.doctorName = `3~40자의 문자만 가능합니다.`;
    } else {
      isValid.value.doctorName = true;
      validMsg.value.doctorName = `입력 완료`;
    }
  }
};
const checkValid_doctorEmail = async () => {
  let reg_doctorEmail = /^[a-z0-9_-].{4,20}@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
  if (doctorRegist.value.doctorEmail === ``) {
    isValid.value.doctorEmail = false;
    validMsg.value.doctorEmail = `필수 입력 사항`;
  } else {
    if (!reg_doctorEmail.test(doctorRegist.value.doctorEmail)) {
      isValid.value.doctorEmail = false;
      validMsg.value.doctorEmail = `5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.`;
    } else {
      isValid.value.doctorEmail = true;
      validMsg.value.doctorEmail = `입력 완료`;
    }
  }
};
const checkValid_password = async () => {
  let reg_password = /(?=.*[a-zA-ZS])(?=.*?[#?!@$%^&*-]).{8,16}/;
  if (doctorRegist.value.password === ``) {
    isValid.value.password = false;
    validMsg.value.password = `필수 입력 사항`;
  } else {
    if (!reg_password.test(doctorRegist.value.password)) {
      isValid.value.password = false;
      validMsg.value.password = `8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.`;
    } else {
      isValid.value.password = true;
      validMsg.value.password = `입력 완료`;
    }
  }
};
const checkValid_passwordRe = async () => {
  let reg_passwordRe = /(?=.*[a-zA-ZS])(?=.*?[#?!@$%^&*-]).{8,16}/;
  if (doctorRegist.value.password === ``) {
    isValid.value.passwordRe = false;
    validMsg.value.passwordRe = `비밀번호를 먼저 입력해 주세요.`;
  } else {
    if (doctorRegist.value.passwordRe === ``) {
      isValid.value.passwordRe = false;
      validMsg.value.passwordRe = `비밀번호를 재확인해 주세요.`;
    } else {
      if (doctorRegist.value.passwordRe !== doctorRegist.value.password) {
        isValid.value.passwordRe = false;
        validMsg.value.passwordRe = `비밀번호가 다릅니다.`;
      } else {
        if (!reg_passwordRe.test(doctorRegist.value.passwordRe)) {
          isValid.value.passwordRe = false;
          validMsg.value.passwordRe = `8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.`;
        }
        isValid.value.passwordRe = true;
        validMsg.value.passwordRe = `입력 완료`;
      }
    }
  }
};
const checkValid_metaverseUrl = async () => {
  let reg_metaverseUrl = /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi;
  if (doctorRegist.value.metaverseUrl === `` || doctorRegist.value.metaverseUrl === `https://`) {
    isValid.value.metaverseUrl = true;
    validMsg.value.metaverseUrl = `선택 입력 사항`;
  } else {
    if (!reg_metaverseUrl.test(doctorRegist.value.metaverseUrl)) {
      isValid.value.metaverseUrl = true;
      validMsg.value.metaverseUrl = `https://로 시작하는 계정 URL를 입력하세요.`;
    } else {
      isValid.value.metaverseUrl = true;
      validMsg.value.metaverseUrl = `입력 완료`;
    }
  }
};
const checkValid_nationality = async () => {
  if (doctorRegist.value.nationality === ``) {
    isValid.value.nationality = false;
    validMsg.value.nationality = `필수 입력 사항`;
  } else {
    if (nationalityList_name.value.indexOf(doctorRegist.value.nationality) !== -1) {
      isValid.value.nationality = true;
      validMsg.value.nationality = `입력 완료`;
    } else {
      isValid.value.nationality = false;
      validMsg.value.nationality = `일치하는 국가명이 없습니다.`;
    }
  }
};
const checkValid_diseases = async () => {
  if (doctorRegist.value.diseases.length === 0) {
    isValid.value.diseases = true;
    validMsg.value.diseases = `선택 입력 사항`;
  } else {
    isValid.value.diseases = true;
    validMsg.value.diseases = `입력 완료`;
  }
};
const checkValid_licenseNumber = async () => {
  if (doctorRegist.value.licenseNumber === ``) {
    isValid.value.licenseNumber = false;
    validMsg.value.licenseNumber = `면허번호를 입력해 주세요.`;
  } else {
    isValid.value.licenseNumber = true;
    validMsg.value.licenseNumber = `입력 완료`;
  }
};
const checkValid_licenseImage = async () => {
  if (doctorRegist.value.licenseImage === null) {
    isValid.value.licenseImage = false;
    validMsg.value.licenseImage = `필수 입력 사항`;
  } else {
    isValid.value.licenseImage = true;
    validMsg.value.licenseImage = `입력 완료`;
  }
};
const checkValid_profileImage = async () => {
  if (doctorRegist.value.profileImage === null) {
    isValid.value.profileImage = false;
    validMsg.value.profileImage = `필수 입력 사항`;
  } else {
    isValid.value.profileImage = true;
    validMsg.value.profileImage = `입력 완료`;
  }
};
const checkValid_affiliationEn = async () => {
  if (doctorRegist.value.affiliationEn === ``) {
    isValid.value.affiliationEn = false;
    validMsg.value.affiliationEn = `필수 입력 사항`;
  } else {
    isValid.value.affiliationEn = true;
    validMsg.value.affiliationEn = `입력 완료`;
  }
};
const checkValid_activityEn = async () => {
  if (doctorRegist.value.activityEn === ``) {
    isValid.value.activityEn = false;
    validMsg.value.activityEn = `필수 입력 사항`;
  } else {
    isValid.value.activityEn = true;
    validMsg.value.activityEn = `입력 완료`;
  }
};
const checkValid_educationEn = async () => {
  if (doctorRegist.value.educationEn === ``) {
    isValid.value.educationEn = false;
    validMsg.value.educationEn = `필수 입력 사항`;
  } else {
    isValid.value.educationEn = true;
    validMsg.value.educationEn = `입력 완료`;
  }
};
const checkValid_affiliationKr = async () => {
  if (doctorRegist.value.affiliationKr === ``) {
    isValid.value.affiliationKr = true;
    validMsg.value.affiliationKr = `선택 입력 사항`;
  } else {
    isValid.value.affiliationKr = true;
    validMsg.value.affiliationKr = `입력 완료`;
  }
};
const checkValid_activityKr = async () => {
  if (doctorRegist.value.activityKr === ``) {
    isValid.value.activityKr = true;
    validMsg.value.activityKr = `선택 입력 사항`;
  } else {
    isValid.value.activityKr = true;
    validMsg.value.activityKr = `입력 완료`;
  }
};
const checkValid_educationKr = async () => {
  if (doctorRegist.value.educationKr === ``) {
    isValid.value.educationKr = true;
    validMsg.value.educationKr = `선택 입력 사항`;
  } else {
    isValid.value.educationKr = true;
    validMsg.value.educationKr = `입력 완료`;
  }
};
const checkValid_affiliationRu = async () => {
  if (doctorRegist.value.affiliationRu === ``) {
    isValid.value.affiliationRu = true;
    validMsg.value.affiliationRu = `선택 입력 사항`;
  } else {
    isValid.value.affiliationRu = true;
    validMsg.value.affiliationRu = `입력 완료`;
  }
};
const checkValid_activityRu = async () => {
  if (doctorRegist.value.activityRu === ``) {
    isValid.value.activityRu = true;
    validMsg.value.activityRu = `선택 입력 사항`;
  } else {
    isValid.value.activityRu = true;
    validMsg.value.activityRu = `입력 완료`;
  }
};
const checkValid_educationRu = async () => {
  if (doctorRegist.value.educationRu === ``) {
    isValid.value.educationRu = true;
    validMsg.value.educationRu = `선택 입력 사항`;
  } else {
    isValid.value.educationRu = true;
    validMsg.value.educationRu = `입력 완료`;
  }
};
const onClick_nationality_box = () => {
  if (!isOn_nationality_option.value) {
    isOn_nationality_option.value = true;
  } else {
    isOn_nationality_option.value = false;
  }
};
const onClick_nationality = async (item: object) => {
  reset_options();
  isOn_nationality_result.value = false;
  nationality_result.value = ``;
  setTimeout(() => {
    nationality_result.value = item;
    doctorRegist.value.nationality = item.countryName;
    isOn_nationality_result.value = true;
  }, 200);
};
const onClick_searchNationality = () => {
  const word = doctorRegist.value.nationality;
  store.dispatch('moduleDr/searchNationality', word, { root: true });
};
const onClick_subjects_box = () => {
  setTimeout(() => {
    if (isOn_subject_option.value) {
      reset_options();
      subject_result.value = null;
      selectedSubject_name = '진료과목 선택';
    } else {
      reset_options();
      isOn_subject_option.value = true;
    }
  }, 200);
};
const onClick_diseases_onSubject_box = () => {
  reset_options();
  if (subject_result.value === null) {
    popupTitle.value = '진료질환 선택';
    popupDesc.value = '진료과목을 먼저 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    if (diseases_onSubject.value.length > 0) {
      setTimeout(() => {
        if (isOn_diseases_option.value) {
          isOn_diseases_option.value = false;
          selectedDisease_name = '진료질환 선택';
        } else {
          isOn_diseases_option.value = true;
        }
      }, 200);
    } else {
      popupTitle.value = '진료질환 선택';
      popupDesc.value = '하위 진료질환이 없습니다. 다른 진료과목을 선택해 주세요.';
      currentPopup.value = ExceptionPopup;
    }
  }
};
const setDiseases_onSubject = (subjectCode: string) => {
  store.dispatch('moduleDr/getDiseases_onSubject', subjectCode, { root: true });
};
const onClick_subject = (item) => {
  isOn_subject_option.value = false;
  subject_result.value = item;
  selectedSubject_name = item.name;
  setDiseases_onSubject(item.code);
};
const onClick_disease_option = async (item) => {
  // reset
  isOn_diseases_option.value = false;
  // get
  if (doctorRegist.value.diseases.length === 0) {
    // [1] dto 최초 생성
    doctorRegist.value.diseases = [
      {
        subject: subject_result.value,
        disease_list: [item],
      },
    ];
    regSubjectCodes.value.push(subject_result.value.code);
    diseases_result.value.push(item);
  } else {
    // [2] dto 추가
    //  1. 진료과목
    //  1. 진료과목`);
    let reIdx = regSubjectCodes.value.indexOf(subject_result.value.code);
    if (reIdx === -1) {
      // (1) 미중복: 새로 추가
      doctorRegist.value.diseases.push({
        subject: subject_result.value,
        disease_list: [item],
      });
      regSubjectCodes.value.push(subject_result.value.code);
      diseases_result.value.push(item);
    } else {
      // (2) 중복: 해당 진료과목에 진료질환 추가
      // (2)-1. 추가
      let subDiseaseCodes = [];
      for (let j = 0; j < doctorRegist.value.diseases[reIdx].disease_list.length; j++) {
        subDiseaseCodes.push(doctorRegist.value.diseases[reIdx].disease_list[j].code);
      }
      if (subDiseaseCodes.indexOf(item.code) === -1) {
        // (2)-1-1. 미중복: 새로 추가
        doctorRegist.value.diseases[reIdx].disease_list.push(item);
        diseases_result.value.push(item);
      } else {
        // (2)-1-2. 중복: 무효.
        popupTitle.value = '진료질환 선택';
        popupDesc.value = '이미 선택한 진료질환입니다.';
        currentPopup.value = ExceptionPopup;
        return;
      }
    }
  }
  // set
  setTimeout(() => {
    console.log(doctorRegist.value.diseases); // subject_disease_dto;
    checkValid_diseases(); // dto 기준으로 수정?
    isOn_diseases_result.value = true;
  }, 200);
};
const setSubjects = async () => {
  await store.dispatch('moduleDr/getSubjects', { root: true });
};
const delete__disease_list_item = async (item) => {
  for (let i = 0; i < doctorRegist.value.diseases.length; i++) {
    for (let j = 0; j < doctorRegist.value.diseases[i].disease_list.length; j++) {
      if (doctorRegist.value.diseases[i].disease_list[j].code === item.code) {
        doctorRegist.value.diseases[i].disease_list.splice(j, 1);
      }
    }
  }
};
const onClick_disease_result_item = async (item, index) => {
  diseases_result.value.splice(index, 1);
  await delete__disease_list_item(item);
  for (let i = 0; i < doctorRegist.value.diseases.length; i++) {
    if (doctorRegist.value.diseases[i].disease_list.length === 0) {
      doctorRegist.value.diseases.splice(i, 1);
    }
  }
  checkValid_diseases();
};
const onLicenseImage = (event) => {
  var input = event.target;
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = (e) => {
      licenseImage.value.url = e.target.result;
      licenseImage.value.thumbnail = e.target.result;
    };
    reader.readAsDataURL(input.files[0]);
    console.log(input.files[0]);
    doctorRegist.value.licenseImage = input.files[0];
  }
};
const onProfileImage = (event) => {
  var input = event.target;
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = (e) => {
      profileImage.value.url = e.target.result;
      profileImage.value.thumbnail = e.target.result;
    };
    reader.readAsDataURL(input.files[0]);
    console.log(input.files[0]);
    doctorRegist.value.profileImage = input.files[0];
  }
};
const changeLicenseImage = async () => {
  let maxSize = 1024 * 200;
  let file = document.getElementById('licenseImage').files[0];
  if (file.size > maxSize) {
    popupTitle.value = '면허 & 여권 사진 첨부';
    popupDesc.value = '200kb이내의 파일을 첨부해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    licenseImage.value.name = file.name;
    licenseImage.value.type = file.type;
    licenseImage.value.size = file.size;
    onLicenseImage(event);
  }
};
const changeProfileImage = async () => {
  let maxSize = 1024 * 200;
  let file = document.getElementById('profileImage').files[0];
  if (file.size > maxSize) {
    popupTitle.value = '프로필 사진 첨부';
    popupDesc.value = '200kb이내의 파일을 첨부해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    profileImage.value.name = file.name;
    profileImage.value.type = file.type;
    profileImage.value.size = file.size;
    onProfileImage(event);
  }
};
const checkVailid_all = () => {
  let v = isValid.value;
  if (
    v.doctorName &&
    v.doctorEmail &&
    v.password &&
    v.passwordRe &&
    v.metaverseUrl &&
    v.nationality &&
    v.diseases &&
    v.licenseNumber &&
    v.licenseImage &&
    v.profileImage &&
    v.affiliationEn &&
    v.activityEn &&
    v.educationEn &&
    v.affiliationKr &&
    v.activityKr &&
    v.educationKr &&
    v.affiliationRu &&
    v.activityRu &&
    v.educationRu
  ) {
    return true;
  } else {
    return false;
  }
};
const regist_default = () => {
  store.dispatch('moduleDr/registDoctorInfo_default', doctorRegist.value, { root: true });
};
const regist_kr = async (doctorSid: number) => {
  let addKr = {
    physician_sid: doctorSid,
    activity: doctorRegist.value.activityKr,
    affiliation: doctorRegist.value.affiliationKr,
    education: doctorRegist.value.educationKr,
    lang: `kr`,
  };
  console.log(addKr);
  await store.dispatch('moduleDr/registDoctorInfo_add', addKr, { root: true });
};
const regist_ru = async (doctorSid: number) => {
  let addRu = {
    physician_sid: doctorSid,
    activity: doctorRegist.value.activityRu,
    affiliation: doctorRegist.value.affiliationRu,
    education: doctorRegist.value.educationRu,
    lang: `ru`,
  };
  console.log(addRu);
  await store.dispatch('moduleDr/registDoctorInfo_add', addRu, { root: true });
};
const onClick_submit = async () => {
  let flag = await checkVailid_all();
  if (flag) {
    regist_default();
  } else {
    popupTitle.value = '의료진 등록';
    popupDesc.value = '입력 정보를 다시 확인해 주세요.';
    currentPopup.value = ExceptionPopup;
    return;
  }
};

/**** content -----------------
 * 의료진 등록
 * /
 * [[       form       ]] -------- 필수 입력 사항 * //
 * /
 * | 기본 정보
 * 01. 이름 *
 * 02. 아이디(이메일) *
 * 03. 메타버스 계정
 * 04. 국가(검색) *
 * 05. 진료과목 *
 * 06. 진료질환 *
 * 07. 의료진 면허번호 *
 * 08. 의료진 면허 & 여권 사진 *
 * 09. 의료진 프로필 사진 *
 * /
 * | 추가 정보 (영어)
 * 10. AFFILIATION
 * 11. ACHIVEMENT/ACTIVITY
 * 12. EDUCATION
 * /
 * [[       submit        ]] ---------------- //
 * /
 * [1] 기본 정보 + 추가 정보 (엉어)
 * [2] 추가 정보 (한국어, 러시아어 각각 선택 가능)
 */

/**** hook -------------------- */
onBeforeMount(() => {
  setSubjects();
  setNationalityList();
});
watch(
  () => doctorRegist.value.doctorName,
  () => {
    doctorRegist.value.doctorName = doctorRegist.value.doctorName.replace(/^[\s\uFEFF\xA0]+/gi, '');
    //doctorRegist.value.doctorName = doctorRegist.value.doctorName.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_doctorName();
  }
);
watch(
  () => doctorRegist.value.doctorEmail,
  () => {
    doctorRegist.value.doctorEmail = doctorRegist.value.doctorEmail.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.doctorEmail = doctorRegist.value.doctorEmail.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_doctorEmail();
  }
);
watch(
  () => doctorRegist.value.password,
  () => {
    doctorRegist.value.password = doctorRegist.value.password.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.password = doctorRegist.value.password.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_password();
  }
);
watch(
  () => doctorRegist.value.passwordRe,
  () => {
    doctorRegist.value.passwordRe = doctorRegist.value.passwordRe.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.passwordRe = doctorRegist.value.passwordRe.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_passwordRe();
  }
);
watch(
  () => doctorRegist.value.metaverseUrl,
  (newValue) => {
    if (newValue === '') {
      doctorRegist.value.metaverseUrl = 'https://';
    }
    doctorRegist.value.metaverseUrl = doctorRegist.value.metaverseUrl.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.metaverseUrl = doctorRegist.value.metaverseUrl.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_metaverseUrl();
  }
);
watch(
  () => doctorRegist.value.nationality,
  () => {
    doctorRegist.value.nationality = doctorRegist.value.nationality.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.nationality = doctorRegist.value.nationality.replace(/\b[a-z]/, (str) => str.toUpperCase());
    checkValid_nationality();
  }
);
watch(
  () => doctorRegist.value.licenseNumber,
  () => {
    doctorRegist.value.licenseNumber = doctorRegist.value.licenseNumber.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorRegist.value.licenseNumber = doctorRegist.value.licenseNumber.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_licenseNumber();
  }
);
watch(
  () => doctorRegist.value.licenseImage,
  () => {
    checkValid_licenseImage();
  }
);
watch(
  () => doctorRegist.value.profileImage,
  () => {
    checkValid_profileImage();
  }
);
watch(
  () => doctorRegist.value.affiliationEn,
  () => {
    checkValid_affiliationEn();
  }
);
watch(
  () => doctorRegist.value.activityEn,
  () => {
    checkValid_activityEn();
  }
);
watch(
  () => doctorRegist.value.educationEn,
  () => {
    checkValid_educationEn();
  }
);
watch(
  () => doctorRegist.value.affiliationKr,
  () => {
    checkValid_affiliationKr();
  }
);
watch(
  () => doctorRegist.value.activityKr,
  () => {
    checkValid_activityKr();
  }
);
watch(
  () => doctorRegist.value.educationKr,
  () => {
    checkValid_educationKr();
  }
);
watch(
  () => doctorRegist.value.affiliationRu,
  () => {
    checkValid_affiliationRu();
  }
);
watch(
  () => doctorRegist.value.activityRu,
  () => {
    checkValid_activityRu();
  }
);
watch(
  () => doctorRegist.value.educationRu,
  () => {
    checkValid_educationRu();
  }
);
watch(
  () => diseases_result.value,
  (newValue: object, oldValue: object) => {
    if (newValue.length === 0) {
      isOn_diseases_result.value = false;
    }
  }
);
watch(
  () => result.value.bool,
  (newValue: boolean, oldValue: boolean) => {
    if (oldValue === true && newValue === false) {
      router.replace({ name: 'DoctorRegistration' });
    }
  }
);
watch(
  () => doctorResult.value,
  (newValue: object, oldValue: object) => {
    // console.log(`------------watch doctor result-- ${newValue}`);
    if (doctorResult.value !== null) {
      // console.log(doctorResult.value.physician_sid);
      if (
        doctorRegist.value.affiliationKr !== `` ||
        doctorRegist.value.activityKr !== `` ||
        doctorRegist.value.educationKr !== `` ||
        doctorRegist.value.affiliationKr !== null ||
        doctorRegist.value.activityKr !== null ||
        doctorRegist.value.educationKr !== null
      ) {
        regist_kr(doctorResult.value.physician_sid);
      }
      if (
        doctorRegist.value.affiliationRu !== `` ||
        doctorRegist.value.activityRu !== `` ||
        doctorRegist.value.educationRu !== `` ||
        doctorRegist.value.affiliationRu !== null ||
        doctorRegist.value.activityRu !== null ||
        doctorRegist.value.educationRu !== null
      ) {
        regist_ru(doctorResult.value.physician_sid);
      }
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("form", _hoisted_4, [
        _createElementVNode("fieldset", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              class: "input-name",
              type: "text",
              name: "doctorName",
              id: "doctorName",
              placeholder: "이름 입력",
              required: "true",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(doctorRegist).doctorName) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).doctorName]
            ]),
            _createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).doctorName ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).doctorName), 3)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "input-id",
              type: "text",
              name: "doctorEmail",
              id: "doctorEmail",
              placeholder: "example@email.com",
              required: "true",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(doctorRegist).doctorEmail) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).doctorEmail]
            ]),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).doctorEmail ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).doctorEmail), 3), [
              [_vShow, _unref(validMsg).doctorEmail !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              class: "input-pw",
              type: "password",
              name: "password",
              id: "password",
              placeholder: "비밀번호 입력",
              required: "true",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(doctorRegist).password) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).password]
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["btn-eyeslash", [{ on: _unref(isOn_eyeslash) }]]),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(onClick_eyeslash)()), ["prevent"]))
            }, "보안", 2),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).password ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).password), 3), [
              [_vShow, _unref(validMsg).password !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              class: "input-pw-re",
              type: "password",
              name: "passwordRe",
              id: "passwordRe",
              placeholder: "비밀번호 확인",
              required: "true",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(doctorRegist).passwordRe) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).passwordRe]
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["btn-eyeslash", [{ on: _unref(isOn_eyeslashRe) }]]),
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(onClick_eyeslashRe)()), ["prevent"]))
            }, "보안", 2),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).passwordRe ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).passwordRe), 3), [
              [_vShow, _unref(validMsg).passwordRe !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "search",
              name: "metaverseUrl",
              id: "metaverseUrl",
              placeholder: "https://",
              required: "true",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(doctorRegist).metaverseUrl) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).metaverseUrl]
            ]),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).metaverseUrl ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).metaverseUrl), 3), [
              [_vShow, _unref(validMsg).metaverseUrl !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              class: "input-search",
              type: "search",
              name: "nationality",
              id: "nationality",
              placeholder: "국가 검색",
              required: "true",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(doctorRegist).nationality) = $event)),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (onClick_nationality_box()))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).nationality]
            ]),
            _createElementVNode("button", {
              class: "btn-search",
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
            }, "검색"),
            _createVNode(_Transition, { name: "selectOption" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nationalityList), (item) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      class: "options",
                      key: item
                    }, [
                      _withDirectives(_createElementVNode("li", {
                        class: "option-list",
                        onClick: ($event: any) => (onClick_nationality(item))
                      }, _toDisplayString(item.countryName), 9, _hoisted_20), [
                        [_vShow, item.countryName.startsWith(_unref(doctorRegist).nationality)]
                      ])
                    ]))
                  }), 128))
                ], 512), [
                  [_vShow, _unref(isOn_nationality_option)]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).nationality ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).nationality), 3), [
              [_vShow, _unref(validMsg).nationality !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", {
              class: _normalizeClass(["option-default", [{ on: _unref(isOn_subject_option) === true }, { selected: _unref(selectedSubject_name) !== '진료과목 선택' }]]),
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (onClick_subjects_box()), ["prevent"]))
            }, _toDisplayString(_unref(selectedSubject_name)), 3),
            _createVNode(_Transition, { name: "selectOption" }, {
              default: _withCtx(() => [
                (_unref(isOn_subject_option))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjects), (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "option-list",
                            key: item,
                            onClick: ($event: any) => (onClick_subject(item))
                          }, _toDisplayString(item.name), 9, _hoisted_25))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", {
              class: _normalizeClass(["option-default", [{ on: _unref(isOn_diseases_option) === true }, { selected: _unref(selectedDisease_name) !== '진료질환 선택' }]]),
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (onClick_diseases_onSubject_box()), ["prevent"]))
            }, _toDisplayString(_unref(selectedDisease_name)), 3),
            _createVNode(_Transition, { name: "selectOption" }, {
              default: _withCtx(() => [
                (_unref(isOn_diseases_option))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("ul", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_onSubject), (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "option-list",
                            key: item,
                            onClick: ($event: any) => (onClick_disease_option(item))
                          }, _toDisplayString(item.name), 9, _hoisted_30))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_unref(isOn_diseases_result))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_result), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "option-result-list",
                      key: item,
                      onClick: ($event: any) => (onClick_disease_result_item(item, index))
                    }, _toDisplayString(item.name), 9, _hoisted_32))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).diseases ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).diseases), 3), [
              [_vShow, _unref(validMsg).diseases !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "licenseNumber",
              id: "licenseNumber",
              placeholder: "면허번호 입력",
              required: "true",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(doctorRegist).licenseNumber) = $event))
            }, null, 512), [
              [_vModelText, _unref(doctorRegist).licenseNumber]
            ]),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).licenseNumber ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).licenseNumber), 3), [
              [_vShow, _unref(validMsg).licenseNumber !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("label", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, [
                  (_unref(licenseImage).size !== 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(licenseImage).thumbnail,
                        alt: "썸네일"
                      }, null, 8, _hoisted_40))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["file-name", [{ on: _unref(licenseImage).size !== 0 }]])
                }, _toDisplayString(_unref(licenseImage).name), 3)
              ]),
              _hoisted_41
            ]),
            _createElementVNode("input", {
              class: "input-file",
              type: "file",
              name: "licenseImage",
              id: "licenseImage",
              placeholder: ".gif, .jpeg, .png (200mb 이하)",
              accept: "image/gif, image/jpeg, image/png",
              onChange: _cache[13] || (_cache[13] = ($event: any) => (changeLicenseImage()))
            }, null, 32),
            _createElementVNode("div", _hoisted_42, [
              (_unref(licenseImage).size !== 0)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(licenseImage).url,
                    alt: "면허 여권 사진 미리보기"
                  }, null, 8, _hoisted_43))
                : _createCommentVNode("", true),
              (_unref(licenseImage).size === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, "미리보기"))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).licenseImage ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).licenseImage), 3), [
              [_vShow, _unref(validMsg).licenseImage !== ``]
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("label", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("span", _hoisted_49, [
                  _withDirectives(_createElementVNode("img", {
                    src: _unref(profileImage).thumbnail,
                    alt: "썸네일"
                  }, null, 8, _hoisted_50), [
                    [_vShow, _unref(profileImage).thumbnail !== ``]
                  ])
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["file-name", [{ on: _unref(profileImage).size !== 0 }]])
                }, _toDisplayString(_unref(profileImage).name), 3)
              ]),
              _hoisted_51
            ]),
            _createElementVNode("input", {
              class: "input-file",
              type: "file",
              name: "profileImage",
              id: "profileImage",
              placeholder: ".gif, .jpeg, .png (200mb 이하)",
              accept: "image/gif, image/jpeg, image/png",
              onChange: _cache[14] || (_cache[14] = ($event: any) => (changeProfileImage()))
            }, null, 32),
            _createElementVNode("div", _hoisted_52, [
              _withDirectives(_createElementVNode("img", {
                src: _unref(profileImage).url,
                alt: "의료진 프로필 사진 미리보기"
              }, null, 8, _hoisted_53), [
                [_vShow, _unref(profileImage).size !== 0]
              ]),
              (_unref(profileImage).size === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_54, "미리보기"))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("p", {
              class: _normalizeClass([_unref(isValid).profileImage ? 'valid-msg-ok' : 'valid-msg'])
            }, _toDisplayString(_unref(validMsg).profileImage), 3), [
              [_vShow, _unref(validMsg).profileImage !== ``]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("section", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("button", {
            class: _normalizeClass(["lang-tab-kr", [{ on: _unref(isOn_tabKr) }]]),
            onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_unref(onClick_tabKr)()), ["prevent"]))
          }, "한국어", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["lang-tab-ru", [{ on: _unref(isOn_tabRu) }]]),
            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_unref(onClick_tabRu)()), ["prevent"]))
          }, "러시아어", 2)
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("form", _hoisted_59, [
            _createElementVNode("fieldset", _hoisted_60, [
              _hoisted_61,
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "affiliationEn",
                  id: "affiliationEn",
                  placeholder: "소속을 영어로 입력해 주세요.",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(doctorRegist).affiliationEn) = $event))
                }, null, 512), [
                  [_vModelText, _unref(doctorRegist).affiliationEn]
                ]),
                _withDirectives(_createElementVNode("p", {
                  class: _normalizeClass([_unref(isValid).affiliationEn ? 'valid-msg-ok' : 'valid-msg'])
                }, _toDisplayString(_unref(validMsg).affiliationEn), 3), [
                  [_vShow, _unref(validMsg).affiliationEn !== ``]
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _withDirectives(_createElementVNode("textarea", {
                  cols: "50",
                  rows: "60",
                  name: "activityEn",
                  id: "activityEn",
                  placeholder: "학술활동/언론보도 내용을 영어로 입력해 주세요.",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(doctorRegist).activityEn) = $event))
                }, null, 512), [
                  [_vModelText, _unref(doctorRegist).activityEn]
                ]),
                _withDirectives(_createElementVNode("p", {
                  class: _normalizeClass([_unref(isValid).activityEn ? 'valid-msg-ok' : 'valid-msg'])
                }, _toDisplayString(_unref(validMsg).activityEn), 3), [
                  [_vShow, _unref(validMsg).activityEn !== ``]
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _withDirectives(_createElementVNode("textarea", {
                  cols: "50",
                  rows: "60",
                  name: "educationEn",
                  id: "educationEn",
                  placeholder: "학력/경력 사항을 영어로 입력해 주세요.",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(doctorRegist).educationEn) = $event))
                }, null, 512), [
                  [_vModelText, _unref(doctorRegist).educationEn]
                ]),
                _withDirectives(_createElementVNode("p", {
                  class: _normalizeClass([_unref(isValid).educationEn ? 'valid-msg-ok' : 'valid-msg'])
                }, _toDisplayString(_unref(validMsg).educationEn), 3), [
                  [_vShow, _unref(validMsg).educationEn !== ``]
                ])
              ])
            ])
          ])
        ]),
        (_unref(isOn_tabKr))
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createElementVNode("fieldset", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "affiliationKr",
                    id: "affiliationKr",
                    placeholder: "소속을 한국어로 입력해 주세요.",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(doctorRegist).affiliationKr) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorRegist).affiliationKr]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).affiliationKr ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).affiliationKr), 3)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _withDirectives(_createElementVNode("textarea", {
                    cols: "50",
                    rows: "60",
                    id: "achivementKr",
                    placeholder: "학술활동/언론보도 내용을 한국어로 입력해 주세요.",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(doctorRegist).activityKr) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorRegist).activityKr]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).activityKr ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).activityKr), 3)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _withDirectives(_createElementVNode("textarea", {
                    cols: "50",
                    rows: "60",
                    id: "educationKr",
                    placeholder: "학력/경력 사항을 한국어로 입력해 주세요.",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(doctorRegist).educationKr) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorRegist).educationKr]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).educationKr ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).educationKr), 3)
                ])
              ])
            ]))
          : (_unref(isOn_tabRu))
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createElementVNode("form", _hoisted_79, [
                  _createElementVNode("fieldset", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "affiliationRu",
                        id: "affiliationRu",
                        placeholder: "소속을 러시아어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(doctorRegist).affiliationRu) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorRegist).affiliationRu]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).affiliationRu ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).affiliationRu), 3)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _withDirectives(_createElementVNode("textarea", {
                        cols: "50",
                        rows: "60",
                        id: "activityRu",
                        placeholder: "학술활동/언론보도 내용을 러시아어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(doctorRegist).activityRu) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorRegist).activityRu]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).activityRu ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).activityRu), 3)
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _hoisted_87,
                      _withDirectives(_createElementVNode("textarea", {
                        cols: "50",
                        rows: "60",
                        id: "educationRu",
                        placeholder: "학력/경력 사항을 러시아어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(doctorRegist).educationRu) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorRegist).educationRu]
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).educationRu ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).educationRu), 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "btn-confirm",
        onClick: _cache[26] || (_cache[26] = ($event: any) => (onClick_submit()))
      }, "확인")
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                onOnClick_close: _cache[27] || (_cache[27] = ($event: any) => (onClick_close())),
                onOnClick_cancel: _cache[28] || (_cache[28] = ($event: any) => (onClick_cancel())),
                onOnClick_confirm: _cache[29] || (_cache[29] = ($event: any) => (onClick_confirm()))
              }, null, 40, ["popup-title", "popup-desc"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "resultPopup" }, {
      default: _withCtx(() => [
        (_unref(result).bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
              _createVNode(ResultPopup, {
                "result-title": _unref(result).title,
                "result-desc": _unref(result).desc,
                onOnClick_close: _cache[30] || (_cache[30] = ($event: any) => (close_resultPopup()))
              }, null, 8, ["result-title", "result-desc"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})